function injectStyle (ssrContext) {
  require("!!vue-loader/node_modules/vue-style-loader!css-loader?minimize!../../node_modules/.12.2.1@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-c5909bd8\",\"scoped\":false,\"hasInlineConfig\":true}!sass-loader!../../node_modules/.12.2.1@vue-loader/lib/selector?type=styles&index=0!./App.vue")
}
var Component = require("!../../node_modules/.12.2.1@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/.12.2.1@vue-loader/lib/selector?type=script&index=0!./App.vue"),
  /* template */
  require("!!../../node_modules/.12.2.1@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-c5909bd8\"}!../../node_modules/.12.2.1@vue-loader/lib/selector?type=template&index=0!./App.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/index/App.vue
// module id = 103
// module chunks = 4